import React from 'react';
import { Badge } from 'antd';
import SgiCtnComponent from './sgiBaseComp/SgiCtnComponent';
import { convertModuleByGuid } from "./SgiCompComm";

export default class SgiBadge extends SgiCtnComponent {
	constructor(props) {
		super(props);
	}

	__fitSonItems() {
		let { moduleDesc, objFct, type } = this.props;
		let { sonItems } = this.state;

		let cldSet = moduleDesc.cldSet || [];
		cldSet.forEach(item => sonItems.push(convertModuleByGuid(this, item, null, objFct, type)));
	}

	//渲染并返回一个虚拟DOM
	__render = () =>
		<Badge {...this.state._props}>
			{this.state.sonItems}
			{this.props.children}
		</Badge>

	__AddAttribute() {
		let { moduleDesc, parentModule } = this.props;
		let { _props, _style, _class } = this.state;

		var text = _props.te;//公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
		if (text) _props.title = text;

		/**
		 * color	自定义小圆点的颜色	string	-	3.16.0
		 * count	展示的数字，大于 overflowCount 时显示为 ${overflowCount}+，为 0 时隐藏	ReactNode		
		 * dot	不展示数字，只有一个小红点	boolean	false	
		 * offset	设置状态点的位置偏移，格式为 [x, y]	[number, number]	-	
		 * overflowCount	展示封顶的数字值	number	99	
		 * showZero	当数值为 0 时，是否展示 Badge	boolean	false	
		 * status	设置 Badge 为状态点	Enum{ 'success', 'processing, 'default', 'error', 'warning' }	''	
		 * text	在设置了 status 的前提下有效，设置状态点的文本	string	''	
		 * title	设置鼠标放在状态点上时显示的文字	string	count	3.5.0
		 */
		if (moduleDesc.color !== undefined) _props.color = moduleDesc.color;
		if (moduleDesc.count !== undefined) _props.count = moduleDesc.count;
		if (moduleDesc.dot !== undefined) _props.dot = moduleDesc.dot;
		if (moduleDesc.overflowCount !== undefined) _props.overflowCount = moduleDesc.overflowCount;
		if (moduleDesc.showZero !== undefined) _props.showZero = moduleDesc.showZero;

	}

}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiBadge.js